class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this._stickyScrollLast = 0;
    this._stickyScrollHandler = null;
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    if (this._stickyScrollHandler) {
      window.removeEventListener("scroll", this._stickyScrollHandler);
      this._stickyScrollHandler = null;
    }
    this._stickyScrollLast = 0;
    const stickyExtraSpace = extraSpace;
    const stickyHeaderHeight = this.headerHeight;
    const stickyMode = this.stickyHeader;
    const cls = this.classes;
    const headerEl = this;
    this._stickyScrollHandler = function onHeaderStickyScroll() {
      const currentScroll = window.scrollY;
      if (currentScroll <= stickyExtraSpace) {
        headerEl.classList.remove(cls.scrollUp, cls.stuck, cls.always);
        document.body.classList.remove(cls.headerScrollUp, cls.headerScrollDown);
        headerEl._stickyScrollLast = currentScroll;
        return;
      }

      if (stickyMode === "on_scroll_up") {
        headerEl.classList.add(cls.stuck);
      } else if (stickyMode === "always") {
        headerEl.classList.add(cls.always);
      }

      const lastScroll = headerEl._stickyScrollLast;
      if (
        currentScroll > stickyHeaderHeight + stickyExtraSpace &&
        currentScroll > lastScroll &&
        !headerEl.classList.contains(cls.scrollDown)
      ) {
        headerEl.classList.remove(cls.scrollUp);
        document.body.classList.remove(cls.headerScrollUp);
        headerEl.classList.add(cls.scrollDown);
        document.body.classList.add(cls.headerScrollDown);
      } else if (currentScroll < lastScroll && headerEl.classList.contains(cls.scrollDown)) {
        headerEl.classList.remove(cls.scrollDown);
        document.body.classList.remove(cls.headerScrollDown);
        headerEl.classList.add(cls.scrollUp);
        document.body.classList.add(cls.headerScrollUp);
      }
      headerEl._stickyScrollLast = currentScroll;
    };
    window.addEventListener("scroll", this._stickyScrollHandler, { passive: true });
  }
}
customElements.define("m-header", MHeader);
